/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TValidatePhoneModel,
  IValidatePhoneRequest,
  IMappers,
  IValidatePhoneResponse,
  IValidatePhoneResponseError,
  TValidatePhoneResponse,
} from './types';

const defaultConfig: TValidatePhoneModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v1/validate-phone/',
  hostType: 'api',
} as TValidatePhoneModel;

function createValidatePhoneModel(parameters: IValidatePhoneRequest): TValidatePhoneModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IValidatePhoneOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IValidatePhoneRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchValidatePhone<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IValidatePhoneOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TValidatePhoneResponse> {
  const { response, statusCode } = await httpApi.fetch(createValidatePhoneModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IValidatePhoneResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IValidatePhoneResponseError);
    }
  }

  return { response, statusCode } as TValidatePhoneResponse;
}

export { defaultConfig, createValidatePhoneModel, fetchValidatePhone };
